import { useState } from 'react';

const faqs = [
  {
    q: '17吃瓜网的视频内容都是真实的吗？',
    a: '我们坚持发布经过多方核实的吃瓜视频和爆料内容。所有视频均来源于公开渠道或用户投稿，编辑团队会对每条内容进行真实性评估后再发布，确保为用户提供可信赖的吃瓜体验。',
  },
  {
    q: '如何在17吃瓜网上观看视频？',
    a: '直接访问17吃瓜网即可在线观看所有吃瓜视频，无需注册或下载任何APP。在首页浏览热门吃瓜内容，或通过话题标签和主题索引查找你感兴趣的爆料视频，点击即可播放。',
  },
  {
    q: '17吃瓜网的内容多久更新一次？',
    a: '我们保持每日更新，编辑团队全天候追踪全网热点。最新黑料视频和爆料内容会在第一时间上线，确保你不会错过任何一个热门吃瓜事件。刷新首页即可看到最新快讯。',
  },
  {
    q: '如何向17吃瓜网投稿爆料？',
    a: '你可以通过页面上的"投稿爆料"入口发送邮件到我们的投稿邮箱。我们承诺严格保护投稿人隐私，所有爆料均以匿名方式处理。如果爆料内容被采纳为专题，投稿人还会获得特别鸣谢。',
  },
  {
    q: '17吃瓜网是否需要付费观看？',
    a: '完全免费！17吃瓜网上所有吃瓜视频、黑料爆料和专题内容均可免费在线观看，没有任何付费墙或会员限制。我们致力于为吃瓜爱好者提供一个开放、免费的内容平台。',
  },
  {
    q: '手机可以访问17吃瓜网吗？',
    a: '当然可以！17吃瓜网已针对手机浏览器进行了全面适配优化。在手机上打开浏览器访问即可获得流畅的观看体验，视频加载快速，界面操作便捷，随时随地刷最新吃瓜内容。',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full mb-3">
            答疑解惑
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            常见问题
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="font-medium text-sm md:text-base text-foreground-800 pr-4">
                  {faq.q}
                </h3>
                <i
                  className={`ri-${
                    openIdx === i ? 'subtract' : 'add'
                  }-line text-lg text-foreground-400 shrink-0 transition-transform duration-300`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === i ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}